import React, { useState } from "react";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { useNavigate } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { useToast } from "@/hooks/use-toast";
import { supabase } from "@/lib/supabaseClient";


const LogInPage = () => {

    const navigate = useNavigate();
    const [username, setUsername] = useState("");
    const [password, setPassword] = useState("");
    const [login, setLogin] = useState(true);
    const { toast } = useToast();

    const handleLogIn = async () => {
        if (!login) {
            const { data, error } = await supabase.auth.signUp({
            email: username,  // replace with email input ideally
            password
            });
            if (error) {
                toast({
                    title: "SignUp Error",
                    description: `Error while signing up: ${error.message}`
                });
            } else {
                toast({ title: "Signup successful" });
                const { data, error } = await supabase.auth.signInWithPassword({
                    email: username,
                    password
                    });
                    if (error) {
                        toast({
                            title: "Login Error",
                            description: `Error while logging in: ${error.message}`
                        });
                    } else {
                        toast({ title: "Login successful" });
                        navigate("/capture");
                    };
            }
        } else {
            const { data, error } = await supabase.auth.signInWithPassword({
            email: username,  // replace with email input ideally
            password
            });
            if (error) {
                toast({
                    title: "Login Error",
                    description: `Error while logging in: ${error.message}`
                });
            } else {
                toast({ title: "Login successful" });
                navigate("/capture");
            }
        }
        };


    return (
        <div className="h-screen flex items-center justify-center">

            <Card className="w-full max-w-md mx-auto">
                <CardHeader>
                    <CardTitle className="text-2xl font-bold text-center">{login ? "login" : "signup"}</CardTitle>
                    <CardDescription className="text-center">
                        Enter your details to continue
                    </CardDescription>
                </CardHeader>
                <CardContent className="space-y-4">
                    <div className="space-y-2">
                        <label htmlFor="username" className="text-sm font-medium">
                            Email
                        </label>
                        <input
                            id="username"
                            type="text"
                            placeholder="Enter your email"
                            className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-purple-500 focus:border-transparent"
                            onChange={(e) => setUsername(e.target.value)}
                        />
                    </div>
                    <div className="space-y-2">
                        <label htmlFor="password" className="text-sm font-medium">
                            Password
                        </label>
                        <input
                            id="password"
                            type="password"
                            placeholder="Enter your password"
                            className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-purple-500 focus:border-transparent"
                            onChange={(e) => setPassword(e.target.value)}
                        />
                    </div>
                </CardContent>
                <CardContent className="flex justify-center">
                    <a className="underline" onClick={() => setLogin(!login)}>{!login ? "login" : "sign-up"}</a>
                </CardContent>
                <CardContent className="flex justify-center">
                    <Button 
                        onClick={handleLogIn}
                        className="bg-gradient-to-r from-purple-500 to-pink-500 hover:from-purple-600 hover:to-pink-600 text-white font-semibold py-4 px-8 rounded-xl text-lg transform transition-all duration-200 hover:scale-105 shadow-lg hover:shadow-xl"
                        >
                            Continue
                    </Button>
                </CardContent>
            </Card>
        </div>
    )
};

export default LogInPage